(function () {
  const STORAGE_KEY = "wishlist_items";

  function safeParseJSON(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function getItems() {
    return safeParseJSON(localStorage.getItem(STORAGE_KEY) || "[]", []);
  }

  function setItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }
  
function notifyWishlistChange() {
  window.dispatchEvent(new CustomEvent("wishlist:change"));
}
  function isSaved(handle) {
    return getItems().includes(handle);
  }

  function toggleItem(handle) {
    let items = getItems();

    if (items.includes(handle)) {
      items = items.filter((x) => x !== handle);
      setItems(items);
      return false;
    } else {
      items.push(handle);
      setItems(items);
      return true;
    }
  }

  function updateButtons() {
    document.querySelectorAll("[data-wishlist-handle]").forEach((el) => {
      const handle = el.getAttribute("data-wishlist-handle");
      if (!handle) return;

      if (isSaved(handle)) {
        el.classList.add("is-active");
      } else {
        el.classList.remove("is-active");
      }
    });
  }

  function updateHeaderWishlistCount() {
    const countEl = document.querySelector(".header__wishlist-count");
    if (!countEl) return;

    const count = getItems().length;
    countEl.textContent = String(count);

    if (count === 0) countEl.classList.add("is-hidden");
    else countEl.classList.remove("is-hidden");
  }

  function showWishlistToast(message) {
    let toast = document.getElementById("wishlist-toast");

    if (!toast) {
      toast = document.createElement("div");
      toast.id = "wishlist-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.style.position = "fixed";
      toast.style.bottom = "18px";
      toast.style.left = "50%";
      toast.style.transform = "translateX(-50%)";
      toast.style.padding = "10px 14px";
      toast.style.borderRadius = "12px";
      toast.style.background = "rgba(0,0,0,0.85)";
      toast.style.color = "#fff";
      toast.style.fontSize = "14px";
      toast.style.zIndex = "999999";
      toast.style.opacity = "0";
      toast.style.transition = "opacity 0.2s ease";
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.style.opacity = "1";

    clearTimeout(window.__wishlistToastTimer);
    window.__wishlistToastTimer = setTimeout(() => {
      toast.style.opacity = "0";
    }, 1400);
  }

  document.addEventListener("click", function (e) {
    const el = e.target.closest("[data-wishlist-handle]");
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = el.getAttribute("data-wishlist-handle");
    if (!handle) return;

    const isNowSaved = toggleItem(handle);

    if (isNowSaved) el.classList.add("is-active");
    else el.classList.remove("is-active");

    updateButtons();
    updateHeaderWishlistCount();

    showWishlistToast(isNowSaved ? "נוסף למועדפים" : "הוסר מהמועדפים");
  });

  document.addEventListener("keydown", function (e) {
    const el = e.target.closest("[data-wishlist-handle]");
    if (!el) return;

    if (e.key !== "Enter" && e.key !== " ") return;

    e.preventDefault();
    e.stopPropagation();

    const handle = el.getAttribute("data-wishlist-handle");
    if (!handle) return;

    const isNowSaved = toggleItem(handle);

    if (isNowSaved) el.classList.add("is-active");
    else el.classList.remove("is-active");

    updateButtons();
    updateHeaderWishlistCount();

    showWishlistToast(isNowSaved ? "נוסף למועדפים" : "הוסר מהמועדפים");
  });

  document.addEventListener("DOMContentLoaded", function () {
    updateButtons();
    updateHeaderWishlistCount();
  });

  document.addEventListener("shopify:section:load", function () {
    updateButtons();
    updateHeaderWishlistCount();
  });

  window.WISHLIST = {
    key: STORAGE_KEY,
    getItems,
    setItems,
    isSaved,
    toggleItem,
    updateButtons,
    updateHeaderWishlistCount,
    showWishlistToast,
  };
})();

